module.exports = __webpack_public_path__ + "media/images/filter-solid-28cbbe1332e7459bba485026febbc758.svg";